import { Typography } from 'antd';
import type { HelpArticlePagerProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { LeftTailArrowIcon } from '@/assets/icons/icons';

const HelpArticlePager = ({
  previous,
  next,
  onOpenArticle,
}: HelpArticlePagerProps) => {
  if (!previous && !next) return null;

  return (
    <div className={styles.articlePager}>
      {/* Empty cell keeps Next on the right when there's no Previous. */}
      {previous ? (
        <button
          type='button'
          className={styles.articlePagerCard}
          onClick={() => onOpenArticle(previous)}
        >
          <Typography.Paragraph
            className={styles.articlePagerTitle}
            ellipsis={{ rows: 2, tooltip: previous.title }}
          >
            {previous.title}
          </Typography.Paragraph>
          <span className={styles.articlePagerLabel}>
            <LeftTailArrowIcon size={12} color='var(--text-primary)' /> Previous
          </span>
        </button>
      ) : (
        <span />
      )}

      {next && (
        <button
          type='button'
          className={`${styles.articlePagerCard} ${styles.articlePagerNext}`}
          onClick={() => onOpenArticle(next)}
        >
          <Typography.Paragraph
            className={styles.articlePagerTitle}
            ellipsis={{ rows: 2, tooltip: next.title }}
          >
            {next.title}
          </Typography.Paragraph>
          <span className={styles.articlePagerLabel}>
            Next{' '}
            <LeftTailArrowIcon
              size={12}
              color='var(--text-primary)'
              style={{ transform: 'scaleX(-1)' }}
            />
          </span>
        </button>
      )}
    </div>
  );
};

export default HelpArticlePager;
